import { render, staticRenderFns } from "./Game3-4.vue?vue&type=template&id=a244709c&scoped=true&"
import script from "./Game3-4.vue?vue&type=script&lang=js&"
export * from "./Game3-4.vue?vue&type=script&lang=js&"
import style0 from "./Game3-4.vue?vue&type=style&index=0&id=a244709c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a244709c",
  null
  
)

export default component.exports